import { useCallback, useContext } from "react"
import {
    RequestTranslationContext,
    useLanguage
} from "@/providers/LanguageProvider"
import { getOverride } from "@/utils/translationOverrides"
import { replaceParams } from "@/utils/replaceParams"

export const useTranslation = () => {
    const { translate, currentLanguage } = useLanguage()
    const requestTranslationRef = useContext(RequestTranslationContext)

    const t = useCallback(
        (
            text: string,
            options?: {
                context?: string
                params?: Record<string, string | number>
            }
        ): string => {
            const override = getOverride(
                currentLanguage,
                text,
                options?.context
            )
            if (override !== undefined) {
                if (options?.params) {
                    return replaceParams(override, options.params)
                }
                return override
            }

            // 翻訳がまだない場合、非同期で翻訳リクエストを送る
            requestTranslationRef.current(text)

            const translated = translate(text)
            if (options?.params) {
                return replaceParams(translated, options.params)
            }
            return translated
        },
        [translate, currentLanguage, requestTranslationRef]
    )

    return { t }
}
